import {
    AfterViewInit,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    OnInit,
    ViewChild,
    TemplateRef,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '@klickdata/core/auth';
import { MessageService } from '@klickdata/core/message';
import { MobileService } from '@klickdata/core/mobile';
import { ResourceOpportunityService } from '@klickdata/core/opportunity';
import { StartResourceService } from '@klickdata/core/resource/src/start-resource.service';
import { ShareService } from '@klickdata/shared-components/src/share/share.service';
import { DownloadHelperService } from 'apps/klickdata/src/app/shared/dialog/download-pdf-dialog/download-helper.service';
import { DashboardUserActivityListComponent } from '../dashboard-user-activity-list/dashboard-user-activity-list.component';

@Component({
    selector: 'app-dashboard-sections-user-activity-list',
    templateUrl: './dashboard-sections-user-activity-list.component.html',
    styleUrls: ['./dashboard-sections-user-activity-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DashboardSectionsUserActivityListComponent
    extends DashboardUserActivityListComponent
    implements AfterViewInit
{
    @ViewChild('playable', { static: true }) playable: TemplateRef<any>;
    @ViewChild('registration', { static: true }) registration: TemplateRef<any>;
    columnsKeys: any = {
        img: { label: $localize`Image`, sortable: false },
        title: { label: $localize`Title`, sortable: true },
        // registration: { label: $localize`Registration`, sortable: false },
        // playable: { label: $localize`Available`, sortable: false },
        type: { label: $localize`Type`, sortable: true },
        done_items: { label: $localize`Progress`, sortable: true },
        examination: { label: $localize`Certificate`, sortable: false },
    };
    constructor(
        protected downloadHelper: DownloadHelperService,
        public shareService: ShareService,
        protected router: Router,
        protected route: ActivatedRoute,
        protected cdr: ChangeDetectorRef,
        protected resourceOpportunityService: ResourceOpportunityService,
        protected mobile: MobileService,
        protected auth: AuthService,
        protected oppoService: ResourceOpportunityService,
        protected messageService: MessageService,
        protected startResourceService: StartResourceService
    ) {
        super(
            downloadHelper,
            shareService,
            router,
            route,
            cdr,
            resourceOpportunityService,
            mobile,
            auth,
            oppoService,
            messageService,
            startResourceService
        );
    }
    ngAfterViewInit(): void {
        this.columnsData['img'] = this.img;
        this.columnsData['title'] = this.title;
        // this.columnsData['registration'] = this.registration;
        // this.columnsData['playable'] = this.playable;
        this.columnsData['type'] = this.type;
        this.columnsData['done_items'] = this.done_items;
        this.columnsData['examination'] = this.examination;
        this.columnsData['tools'] = this.tools;
        this.otherContext['expansionContext'] = this.expansionContextTemplate;
        this.otherContext['multipleSelectionActions'] = this.multipleSelectionActionsTemplate;

        // this.otherContext['multipleSelectionActions'] = this.multipleSelectionActions;
    }
}
